import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Production host for canonical URLs. The static HTML already carries the right tag
// (scripts/seo.js); this keeps it in step on client-side navigation.
export const SITE_ORIGIN = 'https://pokeblunder.pages.dev';

export function canonicalUrl(pathname) {
  const clean = (pathname || '/').replace(/\/+$/, '') || '/';
  return `${SITE_ORIGIN}${clean}`;
}

function Canonical() {
  const { pathname } = useLocation();
  useEffect(() => {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl(pathname));
    const og = document.querySelector('meta[property="og:url"]');
    if (og) og.setAttribute('content', canonicalUrl(pathname));
  }, [pathname]);
  return null;
}

export default Canonical;
